import React, { Component } from 'react';
import dompurify from 'dompurify';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';

import { WrappedButtonType } from '../ui/button';
import { Modal } from './Modal.component';

export class MessageModal extends Component {
	/**
	 * `dangerouslySetInnerHTML` is React's replacement for using `innerHtml` in the browser DOM.
	 * It is advised to use cautiously, so we're utilizing `DOMPurify` node package to strengthen
	 * the security. For more information, visit http://jira/browse/WEBAPPS-19690.
	 */
	renderDescription = description => (
		<div
			className="message-modal-body-description"
			data-qa="message-modal-desc"
			{...{ dataqa: 'message-modal-desc' }}
			// eslint-disable-next-line
			dangerouslySetInnerHTML={{
				__html: isString(description) ? dompurify.sanitize(description) : '',
			}}
		/>
	);

	render() {
		const {
			data: {
				size = 'small',
				primaryButtonType = null,
				primaryButtonText = null,
				secondaryButtonType = null,
				description = '',
				secondaryButtonText = null,
				title = '',
			},
			modalId,
		} = this.props;

		// build primary button config
		const primaryButton = primaryButtonType
			? {
					type: primaryButtonType,
					text: primaryButtonText,
			  }
			: null;

		// build secondary button config
		const secondaryButton = secondaryButtonType
			? {
					type: secondaryButtonType,
					text: secondaryButtonText,
			  }
			: null;

		return (
			<Modal
				modalId={modalId}
				className="message-modal"
				header={title}
				primaryButton={primaryButton}
				secondaryButton={secondaryButton}
				size={size}
			>
				<div className="message-modal-body">{this.renderDescription(description)}</div>
			</Modal>
		);
	}
}

MessageModal.propTypes = {
	data: PropTypes.shape({
		size: PropTypes.string,
		primaryButtonType: PropTypes.oneOf([WrappedButtonType.Primary]),
		primaryButtonText: PropTypes.string,
		secondaryButtonType: PropTypes.oneOf([WrappedButtonType.Secondary]),
		description: PropTypes.string,
		secondaryButtonText: PropTypes.string,
		title: PropTypes.string,
	}),
	modalId: PropTypes.number.isRequired,
};
